<template>
  <el-popover placement="bottom" width="80" trigger="hover">
    <div v-for="(item,index) in list" :key="index" @click="seleteChange(item.id)" class="select-type">
      <span style="">{{item.name}}</span>
      <i
        class="el-icon-check"
        v-if="nowValue==item.id"
        style="color: rgb(199, 0, 10) !important;font-size:12px;line-height:30px"
      ></i>
    </div>
    <span slot="reference">
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
  </el-popover>
</template>
 
<script>
export default {
  data() {
    return {
      nowValue: null,
      value: "",
      show: true,
      list: [{id:null,name:"全部"}]
    };
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch: {
    defaultValue(newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  mounted(){
    this.getDistributionLevelList();
  },
  methods: {
    seleteChange(value) {
      this.nowValue = value;
      this.$emit("selectChange", value);
    },
    getDistributionLevelList(){
      this.api.distributionLevel.getDistributionLevelList().then(result => {
          result.data.forEach(element => {
          this.list.push(element)
        });
      });
    },
    
  }
};
</script>
<style scoped>
.select-type{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  cursor: pointer;
  font-size: 14px;
}
.el-popover {
  width: 80px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/distributionStatistics/SelectHeader.vue